export default "__VITE_ASSET__KZqv9PAp__"